import * as yup from "yup";

/**
 * Time Alerts Settings Validation Schema
 * - type is required (voice | media)
 * - when type is media, file upload is required (media.url or media.file)
 * - when type is voice, country, station_code, and station_name are required
 * - repeat_days must have at least one day selected
 */
export const timeAlertsValidationSchema = () => {
    const timeAlertGroupSchema = yup.object().shape({
        id: yup.string().required(),
        time: yup.string().required("請選擇時間"),
        type: yup.string().oneOf(["voice", "media"]).required("請選擇類型"),
        repeat_days: yup
            .array()
            .of(yup.number().oneOf([1, 2, 3, 4, 5, 6, 7]))
            .min(1, "至少勾選一天")
            .required("請至少勾選一天"),
        voice: yup.object().when("type", {
            is: "voice",
            then: (schema) =>
                schema
                    .shape({
                        country: yup.string().required("請選擇縣市"),
                        station_code: yup.string().required("氣象站代碼為必填"),
                        station_name: yup.string().required("請選擇氣象站"),
                    })
                    .required(),
            otherwise: (schema) => schema.nullable().notRequired(),
        }),
        media: yup.object().when("type", {
            is: "media",
            then: (schema) =>
                schema
                    .shape({
                        url: yup.string(),
                        asset_id: yup.string(),
                        type: yup.string().oneOf(["image", "video"]),
                        file: yup.mixed<File>().nullable(),
                    })
                    .test("file-or-url", "請上傳檔案", function (mediaVal) {
                        const m = mediaVal as { url?: string; file?: File } | undefined;
                        const hasUrl = !!(m?.url && String(m.url).trim() !== "");
                        const hasFile = m?.file instanceof File;
                        return hasUrl || hasFile;
                    })
                    .required(),
            otherwise: (schema) => schema.nullable().notRequired(),
        }),
    });

    return yup.object().shape({
        enabled_time_alerts: yup.boolean().required(),
        data: yup.array().of(timeAlertGroupSchema),
    });
};
